import React, { useRef } from 'react'
import useMakeGraph from './useMakeGraph'
import makeSpec from './makePerWeekSpec'  // Updated spec function
import moment from 'moment'

// Function to get the appropriate time period name based on the timespan
const getTimePeriodName = (timespan) => {
  if (!timespan) return 'Weekly';
  
  const now = moment();
  const diff = now.diff(timespan, 'days');
  
  if (diff <= 7) return 'Weekly';
  if (diff <= 31) return 'Monthly';
  if (diff <= 93) return '3-Month';
  if (diff <= 186) return '6-Month';
  if (diff <= 366) return 'Yearly';
  
  return 'Weekly'; // Default fallback
}

export default function PerWeek({ projects, timespan }) {
  const ref = useRef(null)
  useMakeGraph(ref, projects, makeSpec)
  
  // Get the appropriate time period name
  const timePeriodName = getTimePeriodName(timespan);
  
  return (
    <div className="background-white margin-right-2 padding-1">
      <h4>{timePeriodName} Project Flow</h4>
      <div className="full-width" ref={ref} />
    </div>
  )
}
